import { ajax } from 'rxjs/ajax';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { handleEvent } from 'config/elasticApm';

import env from 'config/env';

const { CONTENT_API_BASE_URL, ENVIRONMENT_NAME } = env;

export default function getAppStatus$({ locale = 'en' }) {
	return ajax.getJSON(`${CONTENT_API_BASE_URL}/${locale}/status`).pipe(
		catchError(error => {
			if (ENVIRONMENT_NAME === 'preprod' && error?.status === 401) {
				window.location.href = '/cognito';
			} else {
				handleEvent({
					error: 'getAppStatusFailed',
					errorContext: {
						failure: error,
						locale,
					},
				});
			}

			return of({});
		})
	);
}
